import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./styles/styles.css";
import "./styles/build.css";
import { BuildPage } from "./build/index.js";
import { App } from "./interface.js";

/**
 * Two routes:
 *
 *   `/`                — landing page. The hero carries the single build
 *                        entry form (link + email + "Build it"), which on
 *                        submit navigates straight to `/build/:slug`.
 *   `/build/:slug`     — Build page: the Pipeline / Review / Rejected
 *                        machine driven by `/kb/{slug}` + the SSE status
 *                        stream, ending on the KB admin (Review) when the
 *                        build is ready.
 *
 * There is no bare `/build` route any more; the hero collects the inputs
 * so the standalone Enter page was removed.
 *
 * The CloudFront distribution rewrites 403/404 to `/index.html` so
 * deep links and refreshes hit React Router correctly.
 */
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element missing");

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/build/:slug" element={<BuildPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
